var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-wrapper"},[(_vm.src2)?_c('v-img',{staticClass:"img-etiqueta",attrs:{"contain":"","src":_vm.urlImg2},on:{"error":_vm.onErrorImg2}}):_vm._e(),_c('v-img',{key:_vm.componentKey,staticClass:"img-principal",attrs:{"contain":"","src":_vm.urlImg},on:{"error":_vm.onErrorImg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }